import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import Alert from 'reactstrap/lib/Alert';
import { Link } from 'react-router-dom';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';

import { receiveProducts } from '@ttstr/actions';
import { Container, LoadingSpinner, Masonry, useIntl } from '@ttstr/components';
import { AppState } from '@ttstr/reducers';
import { useActions, useShallowEqualSelector } from '@ttstr/utils';
import FilteredMasonry from './FilteredMasonry';

const ProductListing: React.FC = () => {
  const { t } = useTranslation();
  const { loading, products } = useShallowEqualSelector(mapStateToProps);
  const { receiveProducts } = useActions(mapDispatchToProps);
  const { language } = useIntl();

  React.useEffect(() => {
    receiveProducts();
  }, [language]);

  return (
    <article>
      {/* <Container fluid className="header-image" /> */}

      <Container className="list-page mb-5">
        <Helmet>
          <title>{t(`PRODUCTS.TITLE`)}</title>
          <body className="product-listing-page" />
        </Helmet>

        <Container className="listing-filter-buttons-container mt-5">
          <Row className="mb-4 d-flex align-items-center justify-content-center listing-buttons-container">
            <Col sm="12" md="12" lg="12" className="mt-2">
              <Link
                to="/products"
                className="btn btn-primary btn-tickets h-100 mr-2 mb-2"
                onClick={() => {
                  const element = document.getElementById('listing');
                  if (!element) return;
                  window.scroll({
                    top: element.offsetTop - 100,
                    behavior: 'smooth',
                  });
                }}
              >
                Alle Artikel
              </Link>
              {/* <Link
              to="/products?tagId=9964"
              className="btn btn-primary btn-tickets h-100  mr-2 mb-2"
              onClick={() => {
                const element = document.getElementById('listing');
                if (!element) return;
                window.scroll({
                  top: element.offsetTop - 100,
                  behavior: 'smooth',
                });
              }}
            >
              Rohdiamant Kollektion
            </Link> */}
              <Link
                to="/products?tagId=9966"
                className="btn btn-primary btn-tickets h-100  mr-2 mb-2"
                onClick={() => {
                  const element = document.getElementById('listing');
                  if (!element) return;
                  window.scroll({
                    top: element.offsetTop - 100,
                    behavior: 'smooth',
                  });
                }}
              >
                Basic Kollektion
              </Link>
              <Link
                to="/products?tagId=9965"
                className="btn btn-primary btn-tickets h-100  mr-2 mb-2"
                onClick={() => {
                  const element = document.getElementById('listing');
                  if (!element) return;
                  window.scroll({
                    top: element.offsetTop - 100,
                    behavior: 'smooth',
                  });
                }}
              >
                Traumfabrik Tour Kollektion
              </Link>
            </Col>
          </Row>
        </Container>

        {loading ? ( // if loading
          <LoadingSpinner label={t(`LOADING.PRODUCTS`)} />
        ) : products.length === 0 ? ( // if no products
          <Alert color="info" className="mt-5">
            {t(`MASONRY.NO_ITEMS`)}
          </Alert>
        ) : (
          // else show products
          <Masonry
            id="product-listing"
            products={products}
            columnClassName="col-sm-12 col-md-6 col-lg-4"
            filters="off"
            showFormerPrice
            showSubtitle
          />
        )}
      </Container>
    </article>
  );
};

const mapStateToProps = (state: AppState) => {
  const { products, loading } = state.Products;
  return {
    products,
    loading,
  };
};

const mapDispatchToProps = {
  receiveProducts,
};

export default React.memo(ProductListing);
